import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createRateSubtaskStyles = ({
  spacing,
  borderRadius,
  typography,
  palette,
}: Theme) => {
  return {
    root: css({
      backgroundColor: grey[100],
      borderRadius: borderRadius.medium,
      padding: spacing([1.5, 1.5, 1]),
      minHeight: 80,
      width: "100%",
      display: "block",
      border: "none",
      outline: "none",
      appearance: "none",
      color: palette.default.text,
      fontWeight: typography.fontWeight.medium,
      fontFamily: typography.fonts.body,
      marginBottom: spacing(1),
    }),
    rated: css({
      opacity: 0.5,
    }),
    loaderWrapper: css({
      width: "100%",
      height: "100%",
      minHeight: 60,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }),
    headerWrapper: css({
      display: "flex",
      justifyContent: "space-between",
    }),
    header: css({
      fontSize: typography.pxToRem(15),
    }),
    points: css({
      flexShrink: 0,
      alignSelf: "flex-start",
    }),
    personWrapper: css({
      display: "flex",
      justifyContent: "space-between",
      margin: spacing([1, 0]),
    }),
    deadline: css({
      fontWeight: typography.fontWeight.semiBold,
      color: grey[800],
    }),
    ratingWrapper: css({
      color: palette.default.text,
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
    }),
    rateInput: css({
      marginBottom: spacing(1),
    }),
    ratingLabel: css({
      margin: spacing([0, 2, 1, 0]),
    }),
    rating: css({
      display: "flex",
      alignItems: "center",
      fontSize: typography.pxToRem(12),
    }),
    stars: css({
      marginLeft: spacing(1),
    }),
  };
};
